import React, { useContext, useEffect, useState } from 'react';
import Header from '../../../components/Common/Header/Header';
import ContentApp from '../../../components/ContentApp';
import Money from '../../../components/Common/Money/Money';
import { useDispatch, useSelector } from 'react-redux';
import { WelletContext } from '../../../context/WelletContext';
import { fetchShow } from '../../../actions/appActions';
import GeneralSelectorPicker from '../../../components/SelectorPicker/GeneralSelectorPicker';
import Button from '../../../components/Common/Button/Button';
import styles from './Form.module.css';
import ReservationCheckCustomerInfo from '../../../components/ReservationCheck/ReservationCheckCustomerInfo/ReservationCheckCustomerInfo';
import useForm from '../../../helpers/useForm';
import { useTranslation } from 'react-i18next';
import { isValidPhoneNumber } from 'react-phone-number-input';
import ButtonProccessing, {
  ButtonStatus,
} from '../../../components/Common/ButtonProccessing/ButtonProccessing';
import InputFormBorder from '../../../components/Common/InputFormBorder/InputFormBorder';
import { putReservation } from '../../../services/reservations/reservationsService';
import { useHistory } from 'react-router-dom';
import { CircleSpinner } from 'react-spinners-kit';
import { Numpad } from '../../../components/Numpad/Numpad';
import { getDateFromOffset } from '../../../helpers/dates';
import { format } from 'date-fns';
import { changeCurrency } from '../../../actions/settingsActions';

const Form = () => {
  const app = useSelector((state) => state.app);
  const welletContext = useContext(WelletContext);
  const dispatch = useDispatch();
  const history = useHistory();
  const { t } = useTranslation();
  const [phoneError, setPhoneError] = useState('');
  const countryCode = useSelector((state) => state.app.currentMarket?.countryCode);
  const currency = useSelector((state) => state.currency.selected);
  const currencies = useSelector((state) => state.currency.all);
  const [loading, setLoading] = useState(true);
  const [selectedType, setSelectedType] = useState(null);
  const [selectedUnit, setSelectedUnit] = useState(null);
  const [selectedTime, setSelectedTime] = useState(1440);
  const [selectedCurrency, setSelectedCurrency] = useState(null);
  const [units, setUnits] = useState(null);
  const [amount, setAmount] = useState(0);
  const [showForm, setShowForm] = useState(false);
  const [errorAmount, setErrorAmount] = useState('');
  const [errorUnit, setErrorUnit] = useState('');
  const [btnStatus, setBtnStatus] = useState(ButtonStatus.Normal);
  const [reservationDate, setReservation] = useState(new Date());

  const currencyOption = (currency) => {
    return {
      value: currency.shortForm,
      label: currency.name,
      isDefault: currency.isDefault,
      symbol: currency.symbol,
    };
  };

  const currenciesOptions = currencies?.map((item) => currencyOption(item));

  const getUnits = async () => {
    try {
      const result = await fetchShow(app.language, '', 1, 100, welletContext, '', '');

      const formattedUnits = result.shows.map((show) => ({
        img: show.logoUrl,
        value: show.id,
        label: show.name,
        additionalCharges: show.additionalCharges,
      }));
      setUnits(formattedUnits);
    } catch (error) {
      console.error(error);
    }
    setLoading(false);
  };

  const handleUnitChange = (selectedOption) => {
    setSelectedUnit(selectedOption);
  };

  const handleCurrencyChange = (selectedOption) => {
    const selectedCurrency = currencies.find((c) => c.shortForm === selectedOption.value);
    dispatch(changeCurrency(selectedCurrency));
    setSelectedCurrency(selectedOption);
  };

  const handleExpireTime = (selectedOption) => {
    setSelectedTime(selectedOption.value);
  };

  const resetForm = () => {
    setShowForm(false);
    setSelectedUnit(null);
    setAmount(null);
  };

  const getShow = async () => {
    try {
      const result = await welletContext.apis.tickets.get(`/shows/get/`, {
        params: {
          showId: selectedUnit.value,
          lang: app.language,
        },
      });

      setReservation(new Date(getDateFromOffset(result.data.utcOffset)));
    } catch (error) {
      console.error(error);
    }
  };

  function validate(values) {
    let errors = {};

    if (!values.customerName) {
      errors.customerName = t('nameError.EMPTY_NAME');
    } else if (/\d/.test(values.customerName)) {
      errors.customerName = t('nameError.NOT_NUMBERS');
    }

    if (!values.customerLastname) {
      errors.customerLastname = t('nameError.EMPTY_LASTNAME');
    } else if (/\d/.test(values.customerLastname)) {
      errors.customerLastname = t('nameError.NOT_NUMBERS');
    }

    if (!values.phone) {
      errors.phone = t('phoneError.EMPTY_PHONE_NUMBER');
      setPhoneError(errors.phone);
    } else {
      setPhoneError('');
    }

    if (values.phone && !isValidPhoneNumber(values.phone)) {
      errors.phone = t('phoneError.INVALID_PHONE_NUMBER');
      setPhoneError(errors.phone);
    }

    if (!values.description) {
      errors.description = t('errorDescription');
    }

    if (!values.externalRefCode) {
      errors.externalRefCode = t('errorInternalReference');
    }

    if (selectedType === 'EMAIL' && !values.email) {
      errors.email = t('emailError.EMPTY_EMAIL');
    }
    if (selectedType === null) {
      errors.selectedType = t('Metodo de envio requerido');
    }
    if (values.email && !/\S+@\S+\.\S+/.test(values.email)) {
      errors.email = t('emailError.INVALID_EMAIL');
    }

    return errors;
  }

  const sendTypes = [
    {
      value: 'EMAIL',
      label: 'E-mail',
    },
    {
      value: 'WHATSAPP',
      label: 'WhatsApp',
    },
    {
      value: 'QR',
      label: 'QR',
    },
    {
      value: 'COPY',
      label: t('copy'),
    },
  ];

  const sendForm = async () => {
    setBtnStatus(ButtonStatus.InProgress);
    const customer = {
      firstName: values.customerName,
      LastName: values.customerLastname,
      email: values.email,
      phone: values.phone,
    };

    try {
      const result = await putReservation(
        selectedUnit.value,
        1,
        customer,
        null,
        null,
        null,
        format(reservationDate, "yyyy-MM-dd'T'HH:mm:ss.SSS"),
        amount,
        [],
        null,
        null,
        'LINK',
        values.description,
        selectedTime,
        selectedType === 'COPY' ? null : selectedType,
        values.externalRefCode,
        welletContext,
        selectedCurrency.value,
      );
      setBtnStatus(ButtonStatus.ProgressFinished);
      setTimeout(() => {
        history.push(`/link-confirmation?reservationId=${result.reservationId}&amount=${amount}`);
      }, 1500);
    } catch (error) {
      setBtnStatus(ButtonStatus.Error);
    }
  };

  const handleContinue = () => {
    setErrorAmount(null);
    setErrorUnit(null);

    const errorMessage = t('amountMinError', { amount: currency.symbol + ' 5' });
    if (parseFloat(amount) < 5) {
      setErrorAmount(errorMessage);
    }
    if (selectedUnit === null) {
      setErrorUnit(t('unitError'));
    }

    if (amount < 5 || selectedUnit === null) return;

    getShow();
    setShowForm(true);
  };

  let { values, errors, handleChange, handleSubmit } = useForm(sendForm, validate);

  const expireTimes = [
    {
      value: 30,
      label: '30 ' + t('minutes'),
    },
    {
      value: 60,
      label: t('hours', { count: 1 }),
    },
    {
      value: 120,
      label: t('hours', { count: 2 }),
    },
    {
      value: 360,
      label: t('hours', { count: 6 }),
    },
    {
      value: 720,
      label: t('hours', { count: 12 }),
    },
    {
      value: 1440,
      label: t('hours', { count: 24 }),
    },
    {
      value: 2880,
      label: '2 ' + t('days'),
    },
    {
      value: 7200,
      label: '5 ' + t('days'),
    },
    {
      value: 14400,
      label: '10 ' + t('days'),
    },
  ];

  useEffect(() => {
    getUnits();
  }, []);

  useEffect(() => {
    if (currency) setSelectedCurrency(currencyOption(currency));
  }, [currency]);

  let additionalChargesResult = [];
  const additionalCharges = selectedUnit?.additionalCharges
    ? selectedUnit?.additionalCharges.filter((charge) => charge.reservationType === 'LINK')
    : [];

  if (additionalCharges.length > 0) {
    additionalCharges.forEach((charge) => {
      if (charge.chargeType === 'PERCENTAGE' && charge.applyOn === 'TOTAL') {
        const percentage = charge.chargeTarget;
        const subtotal = amount;
        const chargeAmount = (percentage / 100.0) * subtotal;
        additionalChargesResult.push({ ...charge, chargeAmount });
      }
    });
  }
  additionalChargesResult.sort((a, b) => a.displayOrder - b.displayOrder);

  const totalAmount =
    amount + additionalChargesResult.reduce((acc, charge) => acc + charge.chargeAmount, 0);

  const Amount = () => {
    return (
      <>
        <Header />
        <ContentApp>
          <div>
            <div>
              <div className='fw-semibold font-medium'>{t('chargeAmount')}</div>
              <div className={styles.inputContainer}>
                <div className='row'>
                  <div className='col-auto px-0'>
                    <div className='keypad-amount-container text-50 line-height-1'>
                      <div className='keypad-amount'>
                        <Money value={amount} convert={false}/>
                      </div>
                    </div>
                    <div className='text-center mt-3'>
                      <GeneralSelectorPicker
                        options={currenciesOptions}
                        selectedValue={currenciesOptions?.find((c) => c.value == currency.shortForm)}
                        onChange={(e) => handleCurrencyChange(e)}
                        placeholder={'Moneda'}
                        styles={{
                          lineHeight: '46px',
                          padding: '0 12px',
                          margin: '0 auto',
                          display: 'inline-block',
                          paddingRight: '46px',
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              {errorAmount && parseFloat(amount) < 5 && (
                <div className='error-label text-center' style={{ position: 'relative' }}>
                  {errorAmount}
                </div>
              )}
            </div>
            <div>
              <div className='mt-3'>
                <GeneralSelectorPicker
                  options={units}
                  selectedValue={selectedUnit}
                  onChange={handleUnitChange}
                  placeholder={t('businessUnit')}
                />
              </div>
              <LinkAmountDetails
                amount={amount}
                additionalCharges={additionalChargesResult}
                totalAmount={totalAmount}
              />
              {errorUnit && !selectedUnit && (
                <div
                  className='error-label text-center'
                  style={{ position: 'relative', marginTop: '10px' }}
                >
                  {errorUnit}
                </div>
              )}

              <Button size='large' text={t('continue')} className='mt-3' onClick={handleContinue} />
              <Numpad
                initialValue={0}
                onValueChange={(value) => setAmount(value)}
                showValue={false}
              />
            </div>
          </div>
        </ContentApp>
      </>
    );
  };

  const Form = () => {
    return (
      <>
        <Header onClick={resetForm} />
        <ContentApp>
          <div className='d-flex align-items-center flex-column'>
            <div className={styles.containerLogo}>
              <img src={selectedUnit.img} alt='logo' />
            </div>
            <div className='font-large fw-semibold mt-3'>{selectedUnit.label}</div>
            <div className='font-smaller mt-1 text-secondary'>{t('paymentLink')}</div>
            <div className='keypad-amount-container text-50 line-height-1 mt-2'>
              <div className='keypad-amount'>
                <Money value={totalAmount} symbol={selectedCurrency.symbol} convert={false}/>
              </div>
            </div>
            <div className='font-smaller text-secondary mt-1'>{selectedCurrency.label}</div>
          </div>

          <div className='mt-3'>
            <div className='fw-semibold text-primary font-tiny mb-3'>
              {t('customerInformation')}
            </div>
            <ReservationCheckCustomerInfo
              handleChange={handleChange}
              values={values}
              errors={errors}
              phoneError={phoneError}
              setPhoneError={setPhoneError}
              countryCode={countryCode}
            />
          </div>

          <div className='mt-4'>
            <div className='fw-semibold text-primary font-tiny mb-3'>{t('linkExpiration')}</div>
            <GeneralSelectorPicker
              options={expireTimes}
              placeholder={t('hours', { count: 24 })}
              selectedValue={{ value: selectedTime }}
              onChange={handleExpireTime}
            />
          </div>

          <div className='fw-semibold text-primary font-tiny mt-4'>
            {t('paymentLinkInformation')}
          </div>
          <div className='mt-3'>
            <InputFormBorder
              color='#757575'
              name='externalRefCode'
              type='text'
              error={errors.externalRefCode}
              onChange={handleChange}
              value={values.externalRefCode}
              placeholder={t('internalReference')}
              customClass='border-none p-0'
            />
          </div>

          <div className='mt-3'>
            <InputFormBorder
              color='#757575'
              name='description'
              type='text'
              error={errors.description}
              onChange={handleChange}
              value={values.description}
              placeholder={t('description')}
              customClass='border-none p-0'
            />
          </div>

          <div className='text-primary font-tiny fw-semibold mt-4'>
            {t('sendPaymentLinkThrough')}
          </div>
          <div className='row mt-3 mx-0'>
            {sendTypes.map((p, i) => (
              <div className='col px-1' key={i}>
                <button
                  onClick={() => setSelectedType(p.value)}
                  className={`font-small w-100 p-0 ${styles.linkButton} ${
                    selectedType === p.value ? styles.selected : ''
                  }`}
                  type='button'
                >
                  {p.label}
                </button>
              </div>
            ))}
          </div>
          {errors.selectedType && (
            <div
              className='error-label text-center'
              style={{ position: 'relative', marginTop: '10px' }}
            >
              {errors.selectedType}
            </div>
          )}
          <ButtonProccessing
            status={btnStatus}
            className={'mt-4'}
            text={t('sendPaymentLink')}
            onClick={handleSubmit}
            arrow
            size='large'
            color='#000'
            backgroundColor='var(--color-primary)'
            iconColor='#000'
          />
        </ContentApp>
      </>
    );
  };

  return (
    <>
      {loading ? (
        <div className='loaderDiv'>
          <CircleSpinner
            className='spinner-app mx-auto'
            style={{ margin: 'auto' }}
            size={40}
            color='var(--color-font-primary)'
          />
        </div>
      ) : showForm ? (
        Form()
      ) : (
        Amount()
      )}
    </>
  );
};

const LinkAmountDetails = ({ amount, additionalCharges, totalAmount }) => {
  if (!additionalCharges || additionalCharges.length === 0) return null;

  const renderAdditionalCharge = (charge) => {
    return (
      <div>
        <div className='row mt-2 fw-500'>
          <div className='col pr-0'>
            {charge.name} ({charge.chargeTarget.toFixed(2)} %):
          </div>
          <div className='col-auto'>
            <Money value={charge.chargeAmount} convert={false} symbolSize='14px' />
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <div>
        <div>
          <div className='row mt-4 fw-500'>
            <div className='col pr-0'>Subtotal:</div>
            <div className='col-auto'>
              <Money value={amount} convert={false} symbolSize='14px' />
            </div>
          </div>
        </div>
        {additionalCharges.map((charge, index) => (
          <div key={index}>{renderAdditionalCharge(charge)}</div>
        ))}
        <div className='row fw-600 mt-2'>
          <div className='col pr-0'>Total:</div>
          <div className='col-auto'>
            <Money value={totalAmount} convert={false} symbolSize='17.6px' />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Form;
